function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ProgressBar from '@nextcloud/vue/dist/Components/ProgressBar';
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'TextResultsLooseWeight',
  components: {
    ProgressBar: ProgressBar
  },
  props: {
    weight: {
      type: Number,
      default: null
    },
    target: {
      type: Number,
      default: null
    },
    initialWeight: {
      type: Number,
      default: null
    },
    unit: {
      type: String,
      default: null
    },
    bounty: {
      type: String,
      default: ''
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState(['activeModule', 'showSidebar', 'weightData'])), mapGetters(['person'])), {}, {
    getProgressbarValue: function getProgressbarValue() {
      if (!this.weight || !this.initialWeight) {
        return null;
      }

      var wantToLoose = this.initialWeight - this.target;
      var result = Math.round((100 - this.diff / wantToLoose * 100) * 100) / 100;
      return result > 100 ? 100 : result;
    },
    diff: function diff() {
      return Math.round((this.initialWeight - this.weight) * 100) / 100;
    },
    toGo: function toGo() {
      return Math.round((this.weight - this.target) * 100) / 100;
    },
    transValues: function transValues() {
      return {
        unit: this.unit,
        weight: this.weight,
        diff: this.diff,
        toGo: this.toGo,
        initialWeight: this.initialWeight,
        target: this.target
      };
    }
  })
};